// environment.staging.ts

import { environmentShared } from './environment.shared';

const env: Partial<typeof environmentShared> = {
  production: true,
  issuer: 'https://okta.apll.com/oauth2/default',
  clientId: '',
  appInsights: {
    instrumentationKey: ''
  }
};

// Export all settings of common replaced by dev options
export const environment = Object.assign(environmentShared, env);
